import styled, { css } from 'styled-components';

import { Checkbox } from '@sternum/ui';
import { TextOverflowBox } from '@sternum/web/components/TextOverflowBox';
import { Colors } from '@sternum/web/components/theme/constants';
import { Config } from '@sternum/web/config';
import { ct } from '@sternum/web/utils/theme';

export const CheckboxContainer = styled.div`
  width: 100%;
  padding-right: 4px;
  flex: 1;
  flex-direction: flex;
  align-items: center;
  display: flex;

  & > div:first-child {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
  }
`;

export const SelectButtonContainer = styled.div`
  display: none;
`;

export const CheckboxStyled = styled(Checkbox)`
  order: -1;

  ${({ indeterminate }) =>
    indeterminate &&
    css`
      background-color: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlueLightest })};
      border-color: ${ct({ Dark: Colors.BrandBlueLightest, Light: Colors.BrandBlueLightest })};
      color: ${ct({ Dark: Colors.BrandBlue, Light: Colors.BrandBlue })};
    `}
`;

export const OptionCountContainer = styled.div``;

export const FilterOptionStyled = styled.div<{ $shouldAddIconPlaceholder?: boolean }>`
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;

  ${({ $shouldAddIconPlaceholder }) =>
    $shouldAddIconPlaceholder &&
    css`
      padding-left: 22px;
    `}

  ${Config.mode !== 'test' &&
  // TODO: when rendered in tests, `hover` specifier is ignored and styles inside
  // are applied regardless, breaking the visibility logic
  css`
    &:hover {
      background-color: ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};
      ${CheckboxContainer} > div > div {
        border: 1px solid ${ct({ Dark: Colors.BrandBlue, Light: Colors.BrandBlue })};
      }
      ${SelectButtonContainer} {
        display: block;
      }
      ${OptionCountContainer} {
        display: none;
      }
    }
  `}
`;

export const CheckboxLabel = styled(TextOverflowBox)`
  color: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
`;
